


import { setGetMailingStatisticsCountTransactionAction } from '../action';
import { getMailingStatisticsCountReplenishment } from '../api/getMailingStatisticsCountReplenishment';

export const setGetMailingStatisticsCountTransaction = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsCountReplenishment({
                ...params,
                status: 'ready_for_pay'
            });

            dispatch(setGetMailingStatisticsCountTransactionAction(data));
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}